import { db } from "../../firebase";
import {
  GET_PROFILE_INTERESTS,
  SET_PROFILE,
  SET_PROFILE_CONTACTS,
  SET_SEARCH_RESULTS,
  SET_SELECTED_PROFILE,
  SET_SELECTED_PROFILE_CONTACTS,
  CLEAR_SEARCH_RESULTS,
  CLEAR_SET_SELECTED_PROFILE,
} from "./actionType";

import {
  collection,
  query,
  where,
  limit,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  orderBy,
} from "firebase/firestore";

export const setProfile = (payload) => ({
  type: SET_PROFILE,
  profile: payload,
});

export const setProfileContacts = (payload) => ({
  type: SET_PROFILE_CONTACTS,
  profileContacts: payload,
});

export const setSearchResult = (payload) => ({
  type: SET_SEARCH_RESULTS,
  profiles: payload,
});

export const setSelectedProfile = (profile) => ({
  type: SET_SELECTED_PROFILE,
  profile: profile,
});

export const setSelectedProfileContacts = (payload) => ({
  type: SET_SELECTED_PROFILE_CONTACTS,
  profileContacts: payload,
});

export const clearSearchResult = () => ({
  type: CLEAR_SEARCH_RESULTS,
});

export const clearSelectedProfile = () => ({
  type: CLEAR_SET_SELECTED_PROFILE,
});

export function getProfile(user) {
  return async (dispatch) => {
    try {
      const profilesRef = collection(db, "profiles");
      const q = query(profilesRef, where("uid", "==", user.uid), limit(1));
      const querySnapshot = await getDocs(q);
      const documents = querySnapshot.docs.map((doc) => ({ docId: doc.id, ...doc.data() }));

      if (documents.length > 0) {
        const profile = documents[0];
        dispatch(getProfileContacts(user, "OWN"));
        dispatch(setProfile(profile));
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export function getProfileContacts(user, who) {
  return async (dispatch) => {
    try {
      const contactsRef = collection(db, "profile_contacts");
      const q = query(contactsRef, where("uid", "==", user.uid), limit(1));
      const querySnapshot = await getDocs(q);
      const documents = querySnapshot.docs.map((doc) => ({ docId: doc.id, ...doc.data() }));

      if (documents.length > 0) {
        const profileContacts = documents[0];
        if (who === "OWN") {
          dispatch(setProfileContacts(profileContacts));
        } else {
          dispatch(setSelectedProfileContacts(profileContacts));
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export async function getProfileDocId(user) {
  const profilesRef = collection(db, "profiles");
  const q = query(profilesRef, where("uid", "==", user.uid), limit(1));
  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    return querySnapshot.docs[0].id;
  }
  return null;
}

export async function addNewProfile(user) {
  const initProfile = {
    display_name: user.displayName,
    uid: user.uid,
    step: 1,
    approved: false,
    premium: false,
  };
  try {
    const docRef = await addDoc(collection(db, "profiles"), initProfile);
    return docRef;
  } catch (err) {
    return err;
  }
}

export function addProfile(user) {
  return async (dispatch) => {
    await addNewProfile(user);
    dispatch(addProfileContacts(user.uid, "", user.email, ""));
    dispatch(getProfile(user));
  };
}

export function updateProfile(user, profile, data) {
  return async (dispatch) => {
    try {
      if (data.mobile && data.mobile !== "") {
        const mobile = data.mobile;
        dispatch(updateProfileContacts(user.uid, mobile));
        data.mobile = "";
      }

      const profileDocRef = doc(db, "profiles", profile.docId);
      await updateDoc(profileDocRef, data);
      dispatch(getProfile(user));
    } catch (err) {
      console.error(err);
    }
  };
}

export async function addUserNameLookup(userName, email) {
  const userNameLookup = {
    userName,
    email,
  };
  try {
    const docRef = await addDoc(collection(db, "username_lookup"), userNameLookup);
    return docRef;
  } catch (err) {
    return err;
  }
}

export function simpleSearch(selections) {
  return async (dispatch) => {
    try {
      const profilesRef = collection(db, "profiles");
      const q = query(
        profilesRef,
        where("gender", "==", selections.gender),
        where("religion", "==", selections.religion),
        where("caste", "==", selections.caste),
        where("dob", "<=", new Date(selections.dob1)),
        where("dob", ">", new Date(selections.dob2)),
        where("approved", "==", true)
      );
      const querySnapshot = await getDocs(q);
      const profiles = querySnapshot.docs.map((doc) => doc.data());
      dispatch(setSearchResult(profiles));
    } catch (err) {
      console.error(err);
    }
  };
}

export function advancedSearch(selections) {
  debugger;
  return simpleSearch(selections); // Same as simpleSearch, you can customize if needed
}

export function getInterestedProfiles(uids) {
  return async (dispatch) => {
    if (uids && uids.length > 0) {
      try {
        const profilesRef = collection(db, "profiles");
        const limitedUids = uids.slice(0, 10);
        const q = query(profilesRef, where("uid", "in", limitedUids));
        const querySnapshot = await getDocs(q);
        const profiles = querySnapshot.docs.map((doc) => doc.data());
        dispatch(setSearchResult(profiles));
      } catch (err) {
        console.error(err);
      }
    }
  };
}

export const setProfileInterests = (interests) => ({
  type: GET_PROFILE_INTERESTS,
  interests,
});

export function getInterests(myUid) {
  return async (dispatch) => {
    try {
      const interestsRef = collection(db, "interests");
      const q = query(interestsRef, where("uid", "==", myUid));
      const querySnapshot = await getDocs(q);
      const interests = querySnapshot.docs.map((doc) => doc.data());
      dispatch(setProfileInterests(interests[0]));
    } catch (err) {
      console.error(err);
    }
  };
}

export function sendInterest(uid, myUid, interest) {
  return async (dispatch) => {
    try {
      const interestsRef = collection(db, "interests");
      const q = query(interestsRef, where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      const interestsDoc = querySnapshot.docs.map((doc) => doc.data());

      if (interestsDoc.length > 0) {
        const interests = interestsDoc[0].interests;
        if (!interests.find(({ senderUid }) => senderUid === myUid)) {
          const docId = querySnapshot.docs[0].id;
          interests.push(interest);
          dispatch(updateInterest(docId, interests));
        }
      } else {
        dispatch(insertInterest(uid, myUid, interest));
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export function insertInterest(uid, myUid, interest) {
  return async () => {
    try {
      await addDoc(collection(db, "interests"), {
        uid,
        interests: [interest],
      });
    } catch (err) {
      console.error(err);
    }
  };
}

export function updateInterest(docId, interests) {
  return async () => {
    try {
      const interestDocRef = doc(db, "interests", docId);
      await updateDoc(interestDocRef, { interests: interests });
    } catch (err) {
      console.error(err);
    }
  };
}

export function addProfileContacts(uid, userName, email, mobile) {
  return async () => {
    const profileContacts = {
      uid,
      userName,
      email,
      mobile,
    };
    try {
      await addDoc(collection(db, "profile_contacts"), profileContacts);
    } catch (err) {
      console.error(err);
    }
  };
}

export function updateProfileContacts(uid, mobile) {
  return async () => {
    try {
      const contactsRef = collection(db, "profile_contacts");
      const q = query(contactsRef, where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const docId = querySnapshot.docs[0].id;
        const profileContactsDocRef = doc(db, "profile_contacts", docId);
        await updateDoc(profileContactsDocRef, { mobile });
      }
    } catch (err) {
      console.error(err);
    }
  };
}
